import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm} from '@angular/forms';
import {DIALOG_CONFIG, SessionService} from 'ac-infra';
import {CustomErrorStateMatcher} from '../../../../utils/custom-error-state-matcher.directive';
import {confirmPasswordValidator} from '../../../../utils/confirm-password-validator.directive';
import * as _ from 'lodash';

@Component({
  selector: 'operators-dialog',
  templateUrl: './operators-dialog.component.html',
  styleUrls: ['./operators-dialog.component.scss']
})
export class OperatorsDialogComponent implements OnInit, AfterViewInit {

  selectedItem: any;
  isEditMode: boolean;
  isLoginSecureEnable: boolean;


  confirmationControl: FormGroup;
  matcher: any;

  @ViewChild('mapForm') form: NgForm;
  securityLevelOptions: any;
  securityPolicyOptions: any;
  securityPolicyError = null;
  lockStatusOptions = [
    {text: 'Active', value: 'ACTIVE'},
    {text: 'Blocked', value: 'BLOCKED'},
    {text: 'Permanent Blocked', value: 'PERMANENT_BLOCKED'}
  ];


  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private sessionService: SessionService) { }

  ngOnInit(): void {
    this.isEditMode = this.dialogConfig.dialogData.isEditMode;
    this.selectedItem = this.dialogConfig.dialogData.selectedItem;
    this.securityPolicyOptions = this.dialogConfig.dialogData.securityPolicies;

    this.dialogConfig.submitButtonDisabled = true;

    this.matcher = new CustomErrorStateMatcher();

    this.confirmationControl = new FormGroup({
      password: new FormControl(),
      userName: new FormControl(),
      'confirm-password': new FormControl(),
      status: new FormControl(),

    }, { validators: confirmPasswordValidator });


    this.selectedItem = this.dialogConfig.dialogData.selectedItem;

    this.securityLevelOptions = this.dialogConfig.dialogData.securityLevels;

    this.isLoginSecureEnable = this.dialogConfig.dialogData.isLoginSecureEnable;
  }

  ngAfterViewInit(): void {
    this.form.form.statusChanges.subscribe(() => {
      this.updateSubmitButtonState();
    });
  }

  updateSubmitButtonState(): void {
    this.dialogConfig.submitButtonDisabled = !this.confirmationControl.valid || _.isEmpty(this.selectedItem.securityPolicyIds);
  }

  isSecurityAdmin(): boolean {
    return this.sessionService.activeSession.role === 'SECURITY_ADMIN';
  }

  securityPolicyFocusout(): void {
    this.securityPolicyError = _.isEmpty(this.selectedItem.securityPolicyIds) ? 'Security Policies is required' : null;
  }

}
